import _ from "lodash";
import everythingAbout from "./tabs/everything-about/index.vue";
import description from "./tabs/description/index.vue";
import structure from "./tabs/description/index.vue";
import recommendation from "./tabs/description/index.vue";
import comments from "./tabs/comments/index.vue";
import comment from "./components/comment-card/index.vue";
import questions from "./tabs/questions/index.vue";
import slider from "./components/slider/index.vue";
import product from "../../components/product/index.vue";
import accordion from "./components/accordion/index.vue";
import ProductPriceOld from "./components/product-price-old/index.vue";
import ProductPriceNew from "./components/product-price-new/index.vue";
import StarRating from "vue-star-rating";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import { getProductPriceTitle, routeToProduct } from "@/helpers";
import { debounce } from "lodash";
import BlackFridayIcon from "@/components/@icons/BlackFridayIcon.vue";
import dynamicsHead from "@/mixins/dynamics-head";

const CardTab = {
  EVERYTHING_ABOUT: 0,
  DESCRIPTION: 1,
  STRUCTURE: 2,
  RECOMMENDATION: 3,
  COMMENTS: 4,
  QUESTIONS: 5,
};

export default {
  name: "card",
  mixins: [dynamicsHead],
  components: {
    BlackFridayIcon,
    everythingAbout,
    description,
    structure,
    recommendation,
    comment,
    comments,
    questions,
    slider,
    Carousel,
    Slide,
    product,
    accordion,
    ProductPriceOld,
    ProductPriceNew,
    StarRating,
  },
  data() {
    return {
      CardTab,
      clientPrices: [],
      sameProducts: [],
      tabs: [
        {
          id: CardTab.EVERYTHING_ABOUT,
          title: "Усе про товар",
        },
        {
          id: CardTab.DESCRIPTION,
          title: "Опис",
        },
        {
          id: CardTab.STRUCTURE,
          title: "Склад",
        },
        {
          id: CardTab.RECOMMENDATION,
          title: "Рекомендації",
        },
        {
          id: CardTab.COMMENTS,
          title: "Відгуки та запитання",
        },
      ],
      currentTab: CardTab.DESCRIPTION,
      selectedCount: 1,
      selectedProductPrice: {},
      leftoverType: null,
      images: [],
      showTimer: false,
      timeRemaining: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      timerInterval: null,
      isExpired: false,
    };
  },
  watch: {
    selectedProductPrice: function (val) {
      this.addImageProduct();
      this.clearTimer();
      this.showTimer = !!val.promotion;
      if (val.promotion && val.promotion.activities) {
        this.$nextTick(() => {
          this.startTimer();
        });
      }
      this.$nextTick(() => {
        this.setPageMetaInfo(this.product)
        this.checkIndexLogic();
      })
    },
  },
  async created() {
    if (this.$route.params.lang === "ru") {
      const tabTranslations = {
        "Опис": "Описание",
        "Усе про товар": "Все о товаре",
        "Склад": "Состав",
        "Рекомендації": "Рекомендации",
        "Відгуки та запитання": "Отзывы и вопросы",
      };
      this.tabs.forEach(el => {
        el.title = tabTranslations[el.title];
      });
    }

    await this.fetchProduct({
      slug: this.$route.params.slug,
      value: this.selectedProductPrice.value,
    });

    this.setPageMetaInfo(this.product)
    this.sendDataLayerInfo();
    this.sendFbqEvent();
    this.checkValue();

    await Promise.all([this.getProductPrice(), this.loadSameProducts()]);

    this.$nextTick(() => {
      this.checkIndexLogic();
    })
  },
  mounted() {
    this.showTimer = !!this.selectedProductPrice.promotion;
    if (this.selectedProductPrice.promotion && this.selectedProductPrice.promotion.activities) {
      this.$nextTick(() => {
        this.startTimer();
      });
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  computed: {
    ...mapGetters({
      productLoading: "card/productLoading",
      product: "card/product",
      productPriceByCount: "card/productPriceByCount",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
      isUserWithCode: "profile/isUserWithCode",
      favourites: "favorites/whichList",
      basket: "basket/basket",
      productsWithDefaultPrices: "basket/productsWithDefaultPrices",
      user: "profile/user",
      isAuthenticated: "auth/isAuthenticated",
      showNotifyLoader: "products/showNotifyLoader",
      isManager: "profile/isManager",
    }),
    showBlackFriday() {
      const blackFridayEndDate = new Date('2025-12-31T23:59:59')
      const now = new Date()
      return now < blackFridayEndDate
    },
    isRefill() {
      return this.selectedProductPrice.isRefill;
    },
    isWithoutBox() {
      return this.selectedProductPrice.withoutBox;
    },
    isOutlet() {
      return (
        this.selectedProductPrice.outletReasons &&
        this.selectedProductPrice.outletReasons.data &&
        this.selectedProductPrice.outletReasons.data.length
      );
    },
    windowSize() {
      return window.innerWidth;
    },
    canBePurchased() {
      return !(this.leftoverType.displayType === "out-stock") && !this.product.hasDuplicate;
    },
    /*unauthorised or authorised without code*/
    isRegularUser() {
      return !(this.isUserWithCode || this.isProfessional || this.isDistributor);
    },
    clientPriceTypeName() {
      return this.isProfessional ? "пацієнта" : "косметолога";
    },
    formattedTimeRemaining() {
      if (this.isExpired) {
        return null;
      }
      const { days, hours, minutes, seconds } = this.timeRemaining;

      // Hide timer if everything is 0
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        return null;
      }

      const pluralizeDays = days => {
        const mod10 = days % 10;
        const mod100 = days % 100;
        if (mod10 === 1 && mod100 !== 11) return `${days} день`;
        if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return `${days} дні`;
        return `${days} днів`;
      };

      if (days === 0) {
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }

      return `${pluralizeDays(days)} ${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    },
  },
  methods: {
    routeToProduct,
    getProductPriceTitle,
    ...mapActions({
      addToFavorite: "favorites/ADD_PRODUCT_TO_FAVOURITES",
      fetchProduct: "card/GET_PRODUCT",
      fetchProductPrice: "card/GET_PRODUCT_PRICE_BY_COUNT",
      fetchSameProduct: "card/GET_SAME_PRODUCTS",
      removeFromFavorite: "favorites/REMOVE_PRODUCT_IN_FAVORITE",
      getFavorites: "favorites/GET_FAVORITES_LIST",
      fetchDefaultPrices: "basket/GET_DEFAULT_PRICE_BASKET",
      fetchData: "products/SET_PRODUCT_WHEN_AVAILABLE",
      showNotifyPopup: "products/SHOW_POPUP_PRODUCT_WHEN_AVAILABLE",
    }),
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      changeLoginPopup: "popups/CHANGE_LOGIN_POPUP",
      changeBasketPopup: "basket/SHOW_BASKET_POPUP",
    }),
    sendFbqEvent() {
      let trackEvent = {
        content_type: "product",
        currency: "UAH",
        content_ids: this.product.unauthorizedProductPriceId,
      };

      if (this.product.brand) {
        trackEvent.content_category = this.product.brand.title;
      }
      if (this.product.brandSeries) {
        trackEvent.content_category = this.product.brandSeries.title;
      }
      trackEvent.content_name = this.product.title;
      trackEvent.value = this.product.productPrices.data[0].price;

      fbq("track", "ViewContent", { ...trackEvent });
    },
    checkIndexLogic() {
      if (this.$route.query.value) {
        this.addNoIndexNoFollow()
      } else {
        this.removeNoIndexNoFollow()
      }
    },
    sendDataLayerInfo() {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: "UAH",
          value: this.product.productPrices.data[0].price,
          items: [
            {
              item_id: this.product.productPrices.data[0].article,
              item_name: this.product.title,
              affiliation: "SkinOn-Cosmetics",
              coupon: "",
              discount: 0.00,
              index: 0,
              item_brand: this.product?.brand?.title || 'SkinOn',
              item_category: this.product?.brandSeries?.title || '',
              item_category2: (() => {
                if (!this.isAuthenticated) return 'unauthorized'
                if (this.isProfessional) return 'professional'
                if (this.isDistributor) return 'distributor'
                return 'regular'
              })(),
              item_list_id: "Cosmetics",
              item_list_name: "Cosmetics",
              location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
              price: this.product.productPrices.data[0].price,
              quantity: 1,
            }
          ]
        }
      });
    },
    checkValue() {
      const productPrices = this.product.productPrices.data;
      const productPrice = _.find(productPrices, productPrice => this.isSelectedPrice(productPrice));
      this.selectProductPrice(productPrice || productPrices[0]);
    },
    showNotify() {
      const payload = {
        product_id: this.product.id,
        product_price_id: this.selectedProductPrice.id,
      };

      this.showNotifyPopup(payload);
    },
    async loadSameProducts() {
      this.sameProducts = await this.fetchSameProduct(this.$route.params.slug);
    },
    async getProductPrice() {
      const products = [
        {
          id: this.product.id,
          select_count: this.selectedCount,
        },
      ];
      await this.fetchDefaultPrices(products);

      this.productsWithDefaultPrices.forEach(product => {
        this.clientPrices = product.productPrices.data;
      });
    },
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.leftoverType = productPrice.leftoverType.data;

      this.selectedProductPrice = productPrice;

      if (this.isSelectedPrice(productPrice)) return;

      this.leftoverType = productPrice.leftoverType.data;
      if (productPrice.id === this.product.productPrices.data[0].id) {
          this.$router.replace({ query: null }).catch(err => {
              if (err.name !== 'NavigationDuplicated') throw err;
          });
      } else {
          this.setPriceValueToQuery(productPrice.value);
      }
    },
    setPriceValueToQuery(value) {
      this.$router.replace({ query: { value } });
    },
    isSelectedPrice(productPrice) {
      return this.selectedProductPrice.value === parseInt(productPrice.value);
    },
    addImageProduct() {
      this.images = _(this.product.images.data)
        .toArray()
        .unshift({ link: this.selectedProductPrice.image, type: "image", iframe: this.selectedProductPrice.iframe })
        .filter(({ link }) => link)
        .map(image => ({ ...image, type: "image" }))
        .push({ link: this.product.video, type: "video" })
        .uniqBy("link")
        .value();
    },

    changeFavorite() {
      if (this.user) {
        const index = this.favourites.find(e => e.productId === this.product.id);
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites();
            this.favoriteSelect = false;
            this.$toasted.success(this.$t("successRemoveFromFavorite"));
          });
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true;
            this.$toasted.success(this.$t("successAddToFavorites"));
            this.getFavorites();
          });
        }
      } else {
        this.changeLoginPopup(true);
      }
    },
    changeTab(val) {
      this.currentTab = val;
    },
    openFastBuy() {
      this.changeFastBuyPopup({
        show: true,
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.product,
        },
      });
    },
    changeCount(type, count) {
      if (type === "decrement" && this.selectedCount > 1) {
        return this.setSelectedCount(this.selectedCount - 1);
      } else if (type === "increment") {
        return this.setSelectedCount(this.selectedCount + 1);
      } else {
        return this.setSelectedCount(count);
      }
    },
    setSelectedCount(count, productPrice = null) {
      this.selectedCount = 0;
      const setQuantity = Math.min(
        Math.max(Number.parseFloat(count || "1"), 1),
        (productPrice || this.selectedProductPrice).quantity
      );

      const newCount = (this.selectedCount = Math.ceil(setQuantity));
      // this.updateProductPrices(newCount);
      return newCount;
    },

    updateProductPrices: debounce(async function (count) {
      await this.fetchProductPrice({
        slug: this.$route.params.slug,
        value: this.$route.query.value,
        count: count,
      });
    }, 300),

    carouselNav($event, direction) {
      const carousel = this.$refs["card-carousel"];
      carousel.advancePage(direction);
    },
    addBasket() {
      this.addToBasket({
        select_count: this.selectedCount,
        product_price: this.selectedProductPrice,
        product: this.product,
        unauthorizedProductPriceId: this.product.unauthorizedProductPriceId,
      });

      // window.dataLayer.push({ ecommerce: null });
      // window.dataLayer.push({
      //   event: "add_to_cart",
      //   ecommerce: {
      //     currency: "UAH",
      //     value: this.selectedProductPrice.price,
      //     items: [
      //       {
      //         item_id: this.selectedProductPrice.article,
      //         item_name: this.product.title,
      //         affiliation: "SkinOn-Cosmetics",
      //         coupon: "",
      //         discount: 0.0,
      //         index: 0,
      //         item_brand: this.product?.brand?.title || "SkinOn",
      //         item_category: this.product?.brandSeries?.title || "",
      //         item_category2: (() => {
      //           if (!this.isAuthenticated) return "unauthorized";
      //           if (this.isProfessional) return "professional";
      //           if (this.isDistributor) return "distributor";
      //           return "regular";
      //         })(),
      //         item_list_id: "Cosmetics",
      //         item_list_name: "Cosmetics",
      //         location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
      //         price: this.selectedProductPrice.price,
      //         quantity: 1,
      //       },
      //     ],
      //   },
      // });
      //
      // // eslint-disable-next-line no-undef
      // fbq("track", "AddToCart", {
      //   content_type: "product",
      //   currency: "UAH",
      //   value: this.selectedProductPrice.price,
      //   content_name: this.product.title,
      //   content_ids: this.product.unauthorizedProductPriceId,
      //   content_category: this.product.brandSeries?.title || this.product.brand?.title || this.product.title,
      // });
      this.changeBasketPopup(true);
      this.$toasted.success(this.$t("successAddBasket"));
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getBasePriceForUser(productPrice) {
      if (this.isUserWithCode) {
        const clientProductPrice = _.find(this.clientPrices, price => price.value === productPrice.value);

        if (!clientProductPrice) {
          return "0";
        }

        return clientProductPrice.basePrice.toFixed(0);
      }

      if (this.priceHasDiscountForProfessional(productPrice)) {
        return productPrice.oldPrice.toFixed(0);
      }

      return "0";
    },
    showClientPriceColumn() {
      /*todo - isDistributor*/
      return (this.isProfessional || this.isDistributor) && _.some(this.clientPrices, ({ typeVisible }) => typeVisible);
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {boolean}
     */
    showClientPrice(productPrice) {
      /*todo - isDistributor*/
      return (
        (this.isProfessional || this.isDistributor) &&
        _.some(this.clientPrices, clientPrice => clientPrice.value === productPrice.value && clientPrice.typeVisible)
      );
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getClientPrice(productPrice) {
      return (
        productPrice.clientPrice && productPrice.clientPrice !== 0 ? productPrice.clientPrice : productPrice.price
      )?.toFixed(0);
    },
    productHasDiscountForSomePrice() {
      if (this.isProfessional || this.isDistributor) {
        return _.some(
          this.product.productPrices.data,
          productPrice => productPrice.hasIndividualDiscount || productPrice.hasActivePromotion
        );
      }

      return _.some(this.product.productPrices.data, productPrice => productPrice.hasActivePromotion);
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {boolean}
     */
    priceHasDiscountForProfessional(productPrice) {
      /*todo - isDistributor*/
      if (!(this.isProfessional || this.isDistributor)) {
        return false;
      }

      return productPrice.hasIndividualDiscount || productPrice.hasActivePromotion;
    },
    professionalHasDiscount() {
      return (this.isProfessional || this.isDistributor) && this.productHasDiscountForSomePrice();
    },
    /**
     * Get the full activity range from all activities
     * @returns {{ dateFrom: Date, dateTo: Date } | null}
     */
    getFullActivityRange() {
      if (!this.selectedProductPrice.promotion?.activities?.data) {
        return null;
      }

      const activities = this.selectedProductPrice.promotion.activities.data;
      if (activities.length === 0) {
        return null;
      }

      let earliestFrom = null;
      let latestTo = null;

      activities.forEach(activity => {
        const dateFrom = this.parseActivityDate(activity.dateFrom);
        const dateTo = this.parseActivityDate(activity.dateTo);

        if (!earliestFrom || dateFrom < earliestFrom) {
          earliestFrom = dateFrom;
        }
        if (!latestTo || dateTo > latestTo) {
          latestTo = dateTo;
        }
      });

      return { dateFrom: earliestFrom, dateTo: latestTo };
    },
    /**
     * Parse activity date string to Date object
     * Format: "2025-11-03 00:00:00"
     * @param {string} dateString
     * @returns {Date}
     */
    parseActivityDate(dateString) {
      const [date, time] = dateString.split(" ");
      const [year, month, day] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);

      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    /**
     * Calculate time remaining until the end of activities
     */
    calculateTimeRemaining() {
      const activityRange = this.getFullActivityRange();

      if (!activityRange) {
        this.isExpired = true;
        this.showTimer = false;
        return;
      }

      const now = new Date();
      const { dateFrom, dateTo } = activityRange;

      if (now < dateFrom) {
        this.isExpired = true;
        this.showTimer = false;
        return;
      }

      const timeDiff = dateTo.getTime() - now.getTime();

      if (timeDiff <= 0) {
        this.isExpired = true;
        this.showTimer = false;
        this.timeRemaining = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        if (this.timerInterval) {
          clearInterval(this.timerInterval);
          this.timerInterval = null;
        }
        return;
      }

      // Calculate remaining time
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      this.timeRemaining = { days, hours, minutes, seconds };
      this.isExpired = false;
    },
    /**
     * Start the countdown timer
     */
    startTimer() {
      this.calculateTimeRemaining();

      if (!this.isExpired) {
        this.timerInterval = setInterval(() => {
          this.calculateTimeRemaining();
        }, 1000);
      }
    },
    /**
     * Clear the timer interval
     */
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
  },
};
